module.exports = __webpack_public_path__ + "img/sad.f064e24c.svg";